import type { Card, CardColor } from "@shared/cards";

/**
 * Local mirror of server canPlay rule — used to highlight playable cards in
 * the PHC hand. The server is authoritative; this is a UX hint only.
 */
export function canPlayCard(
  card: Card,
  top: Card | null,
  currentColor: CardColor | null,
): boolean {
  if (card.color === "wild") return true;
  if (!top) return true;
  const effective = top.color === "wild" ? currentColor : top.color;
  if (effective && card.color === effective) return true;
  if (card.value === top.value) return true;
  return false;
}
